const NoBlog = () => {
  return (
    <div className="inline-flex flex-col items-center gap-4 ">
      <img src="/images/blog_empty.svg" alt="No Blog Available" />
      <span className="text-[#627C93] text-center text-lg leading-7">
        No blogs available in this category yet
      </span>
    </div>
  );
};

export default NoBlog;
